<template>
    <tr>
        <td colspan="2">
            <v-icon v-if="mode === 'manager'" class="hoverRed" @click="deleteQuestion">mdi-close</v-icon>
            {{ data.question }}
        </td>
        <td>
            <v-icon small v-if="data.file !== null && data.file !== ''" @click="viewFile('telegram', data.file)" color="success">mdi-file-find</v-icon>
            <v-icon v-if="mode === 'manager'" @click="selectFile('main')" small>mdi-dots-horizontal</v-icon>
        </td>
        <td colspan="3"></td>
        <td class="text-center">
            <v-icon v-if="mode === 'manager'" :color="commentColor" class="hoverInfo" small @click="editComment">mdi-chat-processing</v-icon>
            <v-icon v-if="mode !== 'manager' && data.comment !== null && data.comment !== '' && data.comment !== ' '" :color="commentColor" class="hoverInfo" small @click="viewComment">mdi-chat-processing</v-icon>
        </td>
        <td>
            <v-checkbox :disabled="mode !== 'manager'" v-model="data.exclude" @change="updateReport" dense hint="Исключить этот пункт из проверки"></v-checkbox>
        </td>
        <td v-if="mode !== 'manager' || stage === 'C30:2'" class="text-center">
            <v-icon small v-if="data.sto_file !== null && data.sto_file !== ''" @click="viewFile('base64', data.sto_file)" color="success">mdi-file-find</v-icon>
            <v-icon v-if="mode !== 'manager' && mode !== 'uk'" @click="selectFile('sto')" small>mdi-dots-horizontal</v-icon>
        </td>
        <td v-if="mode !== 'manager' || stage === 'C30:2'" class="text-center">
            <v-icon v-if="mode !== 'manager' && mode !== 'uk'" :color="stoCommentColor" class="hoverInfo" small @click="editComment">mdi-chat-processing</v-icon>
            <v-icon v-if="(mode === 'manager' || mode === 'uk') && data.sto_comment !== null && data.sto_comment !== ''" :color="stoCommentColor" class="hoverInfo" small @click="viewComment('sto')">mdi-chat-processing</v-icon>
        </td>
    </tr>
</template>

<script>
  export default {
    name: 'ShopperAdditionalRow',
    props: {
      mode: String,
      data: Object,
      stage: String,
      ind: Number
    },
    data: () => ({}),
    computed: {
      commentColor() {
        return (this.data.comment !== null && this.data.comment !== '') ? `success` : ``
      },
      stoCommentColor() {
        return (this.data.sto_comment !== null && this.data.sto_comment !== '') ? `success` : ``
      },
    },
    methods: {
      viewFile: function(mode = 'telegram', file = null) {
        if(file !== null) {
          this.$emit('viewfile', {
            mode,
            file
          })
        }
      },
      selectFile: function(fileType = 'main') {
        let data
        data = {
          type: fileType,
          mode: this.mode,
          index: this.ind,
          rows: 'additionalQuestions'
        }
        this.$emit('selectfile', data)
      },
      viewComment: function (type = null) {
        if(type === 'manager') {
          this.$emit('viewcomment', this.data.comment)
        } else if (type === 'sto') {
          this.$emit('viewcomment', this.data.sto_comment)
        }
      },
      editComment: function() {
        let data
        data = {
          mode: this.mode,
          index: this.ind,
          rows: 'additionalQuestions'
        }
        this.$emit('editcomment', data)
      },
      deleteQuestion: function () {
        this.$emit('deletequestion', this.ind)
      },
      updateReport: function () {
        this.$emit('updatereport')
      },
    },
  }
</script>

<style scoped>
    .hoverRed:hover {
        color: red;
    }

    .hoverInfo:hover {
        color: #2196F3;
    }
</style>